import { motion } from 'framer-motion';
import { ComponentProps } from 'react';

export const AnimatedPopup = (props: ComponentProps<any>) => {
    return <motion.div
        variants={{
            hidden: {
                scale: 0,
                opacity: 0,
            },
            visible: {
                opacity: 1,
                scale: 1,
                transition: {
                    duration: 0.2,
                    type: "ease",
                },
            },
        }}
        exit="hidden"
        initial="hidden"
        animate="visible"
        {...props}
    />;
}